var nunjucks = require("nunjucks/browser/nunjucks-slim");
var env;
if (!nunjucks.currentEnv){
	env = nunjucks.currentEnv = new nunjucks.Environment([], undefined);
} else {
	env = nunjucks.currentEnv;
}
var configure = require("../nunjucks.config.runtime.js")(env);
var dependencies = nunjucks.webpackDependencies || (nunjucks.webpackDependencies = {});




var shim = require("/var/www/app/node_modules/nunjucks-loader/runtime-shim");


(function() {(nunjucks.nunjucksPrecompiled = nunjucks.nunjucksPrecompiled || {})["assets/app/utils/macros.html"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = 0;
var colno = 0;
var output = "";
try {
var parentTemplate = null;
var macro_t_1 = runtime.makeMacro(
["id"], 
["bound", "style", "classes"], 
function (l_id, kwargs) {
var callerFrame = frame;
frame = new runtime.Frame();
kwargs = kwargs || {};
if (Object.prototype.hasOwnProperty.call(kwargs, "caller")) {
frame.set("caller", kwargs.caller); }
frame.set("id", l_id);
frame.set("bound", Object.prototype.hasOwnProperty.call(kwargs, "bound") ? kwargs["bound"] : "");frame.set("style", Object.prototype.hasOwnProperty.call(kwargs, "style") ? kwargs["style"] : false);frame.set("classes", Object.prototype.hasOwnProperty.call(kwargs, "classes") ? kwargs["classes"] : "");var t_2 = "";t_2 += "<svg";
if(runtime.contextOrFrameLookup(context, frame, "bound")) {
t_2 += " viewBox=\"";
t_2 += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "bound"), env.opts.autoescape);
t_2 += "\"";
;
}
t_2 += "\n                       class=\"svg svg--";
t_2 += runtime.suppressValue(l_id, env.opts.autoescape);
t_2 += " ";
if(runtime.contextOrFrameLookup(context, frame, "classes")) {
t_2 += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "classes"), env.opts.autoescape);
;
}
t_2 += "\">\n        <use xlink:href=\"";
t_2 += runtime.suppressValue((lineno = 3, colno = 34, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "static"), "static", context, ["svg/symbol/svg/sprite.symbol.svg"])), env.opts.autoescape);
t_2 += "#";
t_2 += runtime.suppressValue(l_id, env.opts.autoescape);
t_2 += "\"></use>\n        ";
t_2 += runtime.suppressValue((lineno = 4, colno = 17, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "caller"), "caller", context, [])), env.opts.autoescape);
t_2 += "\n    </svg>";
;
frame = callerFrame;
return new runtime.SafeString(t_2);
});
context.addExport("svg_sprite");
context.setVariable("svg_sprite", macro_t_1);
output += "\n\n\n";
var macro_t_3 = runtime.makeMacro(
["component"], 
["mods", "classes", "data"], 
function (l_component, kwargs) {
var callerFrame = frame;
frame = new runtime.Frame();
kwargs = kwargs || {};
if (Object.prototype.hasOwnProperty.call(kwargs, "caller")) {
frame.set("caller", kwargs.caller); }
frame.set("component", l_component);
frame.set("mods", Object.prototype.hasOwnProperty.call(kwargs, "mods") ? kwargs["mods"] : []);frame.set("classes", Object.prototype.hasOwnProperty.call(kwargs, "classes") ? kwargs["classes"] : "");frame.set("data", Object.prototype.hasOwnProperty.call(kwargs, "data") ? kwargs["data"] : {});var t_4 = "";if(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"item")) {
var t_5;
t_5 = runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"item");
frame.set("item", t_5, true);
if(frame.topLevel) {
context.setVariable("item", t_5);
}
if(frame.topLevel) {
context.addExport("item", t_5);
}
;
}
var tasks = [];
tasks.push(
function(callback) {
env.getTemplate(l_component, false, "assets/app/utils/macros.html", false, function(t_7,t_6) {
if(t_7) { cb(t_7); return; }
callback(null,t_6);});
});
tasks.push(
function(template, callback){
template.render(context.getVariables(), frame, function(t_9,t_8) {
if(t_9) { cb(t_9); return; }
callback(null,t_8);});
});
tasks.push(
function(result, callback){
t_4 += result;
callback(null);
});
env.waterfall(tasks, function(){
t_4 += runtime.suppressValue((lineno = 13, colno = 36, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "caller"), "caller", context, [])), env.opts.autoescape);
});
frame = callerFrame;
return new runtime.SafeString(t_4);
});
context.addExport("include_component");
context.setVariable("include_component", macro_t_3);
output += "\n\n\n";
var macro_t_10 = runtime.makeMacro(
["className", "path"], 
["sizes", "lazy"], 
function (l_className, l_path, kwargs) {
var callerFrame = frame;
frame = new runtime.Frame();
kwargs = kwargs || {};
if (Object.prototype.hasOwnProperty.call(kwargs, "caller")) {
frame.set("caller", kwargs.caller); }
frame.set("className", l_className);
frame.set("path", l_path);
frame.set("sizes", Object.prototype.hasOwnProperty.call(kwargs, "sizes") ? kwargs["sizes"] : "");frame.set("lazy", Object.prototype.hasOwnProperty.call(kwargs, "lazy") ? kwargs["lazy"] : true);var t_11 = "";t_11 += "\n    ";
var t_12;
t_12 = "";
frame.set("srcset", t_12, true);
if(frame.topLevel) {
context.setVariable("srcset", t_12);
}
if(frame.topLevel) {
context.addExport("srcset", t_12);
}
t_11 += "\n    ";
var t_13;
t_13 = "";
frame.set("srcset2x", t_13, true);
if(frame.topLevel) {
context.setVariable("srcset2x", t_13);
}
if(frame.topLevel) {
context.addExport("srcset2x", t_13);
}
t_11 += "\n    ";
var t_14;
t_14 = "";
frame.set("srcset3x", t_14, true);
if(frame.topLevel) {
context.setVariable("srcset3x", t_14);
}
if(frame.topLevel) {
context.addExport("srcset3x", t_14);
}
t_11 += "\n\n    ";
frame = frame.push();
var t_17 = [540,720,960,1280,1600,1920,2560];
if(t_17) {t_17 = runtime.fromIterator(t_17);
var t_16 = t_17.length;
for(var t_15=0; t_15 < t_17.length; t_15++) {
var t_18 = t_17[t_15];
frame.set("i", t_18);
frame.set("loop.index", t_15 + 1);
frame.set("loop.index0", t_15);
frame.set("loop.revindex", t_16 - t_15);
frame.set("loop.revindex0", t_16 - t_15 - 1);
frame.set("loop.first", t_15 === 0);
frame.set("loop.last", t_15 === t_16 - 1);
frame.set("loop.length", t_16);
t_11 += "\n    ";
var t_19;
t_19 = runtime.contextOrFrameLookup(context, frame, "srcset3x") + (lineno = 23, colno = 43, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "static"), "static", context, [l_path + "@" + t_18 + ".webp"])) + " " + Math.floor((t_18 * 3 / 2) / 1) + "w" + ((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "loop")),"last")?"":", "));
frame.set("srcset3x", t_19, true);
if(frame.topLevel) {
context.setVariable("srcset3x", t_19);
}
if(frame.topLevel) {
context.addExport("srcset3x", t_19);
}
t_11 += "\n    ";
var t_20;
t_20 = runtime.contextOrFrameLookup(context, frame, "srcset2x") + (lineno = 24, colno = 43, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "static"), "static", context, [l_path + "@" + t_18 + ".webp"])) + " " + Math.floor((t_18 * 4 / 3) / 1) + "w" + ((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "loop")),"last")?"":", "));
frame.set("srcset2x", t_20, true);
if(frame.topLevel) {
context.setVariable("srcset2x", t_20);
}
if(frame.topLevel) {
context.addExport("srcset2x", t_20);
}
t_11 += "\n    ";
var t_21;
t_21 = runtime.contextOrFrameLookup(context, frame, "srcset") + (lineno = 25, colno = 39, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "static"), "static", context, [l_path + "@" + t_18 + ".webp"])) + " " + t_18 + "w" + ((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "loop")),"last")?"":", "));
frame.set("srcset", t_21, true);
if(frame.topLevel) {
context.setVariable("srcset", t_21);
}
if(frame.topLevel) {
context.addExport("srcset", t_21);
}
t_11 += "\n    ";
;
}
}
frame = frame.pop();
t_11 += "\n\n    <picture>\n        <source srcset=\"";
t_11 += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "srcset3x"), env.opts.autoescape);
t_11 += "\" media=\"(min-resolution: 3dppx)\" ";
t_11 += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "sizes"), env.opts.autoescape);
t_11 += " type=\"image/webp\">\n        <source srcset=\"";
t_11 += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "srcset2x"), env.opts.autoescape);
t_11 += "\" media=\"(min-resolution: 2dppx)\" ";
t_11 += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "sizes"), env.opts.autoescape);
t_11 += " type=\"image/webp\">\n        <source srcset=\"";
t_11 += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "srcset"), env.opts.autoescape);
t_11 += "\" ";
t_11 += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "sizes"), env.opts.autoescape);
t_11 += " type=\"image/webp\">\n        <img class=\"";
t_11 += runtime.suppressValue(l_className, env.opts.autoescape);
t_11 += "\" src=\"";
t_11 += runtime.suppressValue((lineno = 32, colno = 51, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "static"), "static", context, [l_path + "@1280.webp"])), env.opts.autoescape);
t_11 += "\" alt=\"\" ";
t_11 += runtime.suppressValue((runtime.contextOrFrameLookup(context, frame, "lazy")?"loading=\"lazy\"":""), env.opts.autoescape);
t_11 += " style=\"background-image: url(";
t_11 += runtime.suppressValue((lineno = 32, colno = 158, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "static"), "static", context, [l_path + "@placeholder.webp"])), env.opts.autoescape);
t_11 += "); background-size: cover\">\n    </picture>\n";
;
frame = callerFrame;
return new runtime.SafeString(t_11);
});
context.addExport("picture");
context.setVariable("picture", macro_t_10);
output += "\n\n\n";
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
;
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};

})();
})();



module.exports = shim(nunjucks, env, nunjucks.nunjucksPrecompiled["assets/app/utils/macros.html"] , dependencies)